/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_User_Otp_SuccessInputs */

const vi_toast_user_otp_success = /** @type {(inputs: Toast_User_Otp_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã cập nhật đăng nhập OTP`)
};

/**

* @param {Toast_User_Otp_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_user_otp_success = /** @type {((inputs?: Toast_User_Otp_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_User_Otp_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_user_otp_success(inputs)
});